import { render } from "./Waveform.vue?vue&type=template&id=a2f05722&scoped=true"
import script from "./Waveform.vue?vue&type=script&lang=js"
export * from "./Waveform.vue?vue&type=script&lang=js"

import "./Waveform.vue?vue&type=style&index=0&id=a2f05722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f05722"]])

export default __exports__